import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d76f49f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 본 위험고지서는 귀하가 (주)엔젤리그가 운영하는 서비스 위에서, 업무집행조합원과 함께 조합에 참여하여 조합을 공동경영하기 전에 출자의 위험을 사전에 충분히 인지할 수 있도록 (주)엔젤리그가 귀하에게 고지하는 내용입니다. ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 내용을 확인했습니다. ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", { class: "detail_list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "귀하의 투자대상은 조합의 지분으로서 투자대상회사의 주식 그 자체가 아닙니다. 설립되는 조합이 비상장주식을 매수하게 되며 귀하는 그 조합의 지분을 보유하게 됩니다."),
  /*#__PURE__*/_createElementVNode("li", null, "조합의 업무집행조합원 및 다른 조합원은 귀하와 조합의 동업자로서, 조합 출자재산의 운영 및 배분은 조합원 전원의 합의로 이루어지고, 업무집행조합원은 조합의 출자재산을 운용하지 않습니다."),
  /*#__PURE__*/_createElementVNode("li", null, "조합의 투자대상인 투자대상회사의 증권은 원금손실의 위험성이 있으며, 투자한 자금의 원금을 회수할 수 없음에 따른 손실의 위험이 있음을 이해합니다. 또한 귀하가 예상하거나 기대하는 수익의 일부 또는 전부를 얻지 못할 수 있습니다."),
  /*#__PURE__*/_createElementVNode("li", null, "귀하는 (주)엔젤리그의 홈페이지에 게재된 투자대상회사에 대한 설명 투자대상회사의 증권 매수조건, 투자대상회사의 증권 매수 시점 및 가격의 내부 의사결정방법, 업무집행조합원의 성과보수, 업무집행조합원의 역할, 투자위험요소 등을 충분히 확인하였습니다."),
  /*#__PURE__*/_createElementVNode("li", null, "귀하는 (주)엔젤리그는 업무집행조합원이 안전하고 쉽게 조합을 만드는 것을 도와주는 역할만 수행하므로 투자손실의 위험을 보전하는 당사자가 아님을 확인합니다. 조합의 업무집행조합원 역시 귀하와 같이 조합을 설립하고 운영하는 동업자로서 투자손실의 위험을 보전하는 당사자가 아님을 확인합니다. 즉, 투자에 대한 모든 위험은 본인에게 있음을 확인합니다."),
  /*#__PURE__*/_createElementVNode("li", null, "귀하는 조합을 통해 매수하는 투자대상회사의 비상장증권은 한국거래소의 상장을 목적으로 하는 것이 아니며, 따라서 증권의 환금성에 큰 제약이 있다는 점과 예상 회수금액에 대한 일부 혹은 전부를 회수할 수 없는 위험이 있음을 이해하며, 귀하가 이를 감당할 수 있음을 확인합니다."),
  /*#__PURE__*/_createElementVNode("li", null, "귀하는 시장의 상황, 제도의 변경이 있을 수 있으며, 자본시장법 등 관련법규에 근거하여 투자의 한도에 제한이 있는 경우 이를 준수하여야 함을 이해합니다.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_toggle_icon = _resolveComponent("ag-toggle-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_text, {
      px: "20px",
      typography: "tit18b"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.stakeNameRef) + " 조합원 자격 구매 ", 1)
      ]),
      _: 1
    }),
    _createVNode(_component_ag_box, {
      p: "32px 20px 24px 20px",
      direction: "column",
      style: {"border-bottom":"1px solid #F9F9FB"},
      dp: "flex"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, null, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, { typography: "main14r" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_box, { p: "14px 30px" }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          "justify-content": "flex-end",
          dp: "flex",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'조합 참여 위험안내', 'clickContent':`내용을 확인했습니다`, clickScreen: _ctx.clickScreen});_ctx.checkAct()})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, {
              typography: "tit16b",
              "padding-right": "12px"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_ag_toggle_icon, {
              name: "check",
              value: _ctx.isChecked
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_box, {
      p: "24px 20px",
      bg: "bg1"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ], 64))
}